import { includes, noop } from 'lodash';
import classnames from 'classnames';
import React from 'react';
import styles from './popover.scss';
import { KEY_CODES } from '../../widget';
import { ScrollbarWrapper } from '../scrollbar-wrapper/scrollbar-wrapper';
export class Popover extends React.Component {
    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick, false);
        document.addEventListener('keydown', this.handleDocumentKeyPress, false);
        window.addEventListener('blur', this.handleWindowBlur, false);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick, false);
        document.removeEventListener('keydown', this.handleDocumentKeyPress, false);
        window.removeEventListener('blur', this.handleWindowBlur, false);
    }
    constructor(props) {
        super(props);
        this.closingPromise = Promise.resolve();
        this.handleWindowBlur = () => {
            if (this.props.isOpen) {
                return;
            }
            this.setIsOpen(false);
        };
        this.handleDocumentClick = (event) => {
            if (!this.containerRef) {
                return;
            }
            if (!this.containerRef.contains(event.target)) {
                if (this.state.isOpen) {
                    this.setIsOpen(false);
                }
            }
        };
        this.handleDocumentKeyPress = (event) => {
            if (!this.containerRef) {
                return;
            }
            if (event.keyCode === KEY_CODES.ESC) {
                if (this.containerRef.contains(event.target)) {
                    this.setOpenFromKeyboard(false);
                    return;
                }
                this.setIsOpen(false);
            }
        };
        this.handleKeyDown = (event) => {
            if (includes([KEY_CODES.DOWN, KEY_CODES.UP, KEY_CODES.SPACE, KEY_CODES.ENTER], event.keyCode)) {
                event.preventDefault();
                if (!this.state.isOpen) {
                    this.setOpenFromKeyboard(true);
                }
            }
        };
        this.setOpenFromKeyboard = (isOpen) => {
            this.setIsOpen(isOpen, () => {
                if (isOpen) {
                    if (this.contentRef && this.props.focusContentOnOpen) {
                        this.contentRef.childNodes[0].focus();
                    }
                }
                else {
                    if (this.openerRef) {
                        this.openerRef.focus();
                    }
                }
            });
        };
        this.toggleOpen = (event) => {
            if (event.type === 'mousedown' && event.button === 0) {
                event.preventDefault();
                this.setIsOpen(!this.state.isOpen);
            }
        };
        this.saveRef = (refName) => (ref) => (this[refName] = ref);
        this.handleContentKeydown = (event) => {
            if (includes([KEY_CODES.SPACE, KEY_CODES.ENTER], event.keyCode)) {
                event.preventDefault();
                this.setOpenFromKeyboard(false);
            }
        };
        this.state = {
            isOpen: props.isOpen,
            isClosing: false,
        };
    }
    UNSAFE_componentWillReceiveProps({ isOpen }) {
        if (isOpen !== this.props.isOpen) {
            this.setIsOpen(isOpen);
        }
    }
    setIsOpen(isOpen, onStateChanged = noop) {
        this.closingPromise.then(() => {
            this.setState({ isClosing: !isOpen });
            if (isOpen) {
                this._setIsOpen(isOpen, onStateChanged);
                return;
            }
            this.closingPromise = new Promise((resolve) => setTimeout(resolve, 300)).then(() => {
                this._setIsOpen(isOpen, onStateChanged);
            });
        });
    }
    _setIsOpen(isOpen, onStateChanged) {
        this.setState({ isOpen, isClosing: false }, onStateChanged);
        this.props.onToggle(isOpen);
    }
    render() {
        const { className, content, children, dataHook, isFocusable, ariaRole, ariaLabel, openerClassName, dropdownPosition, } = this.props;
        const { isOpen, isClosing } = this.state;
        return (React.createElement("div", { ref: this.saveRef('containerRef'), "data-hook": "popover-container", className: styles.container },
            React.createElement("div", { role: ariaRole, className: openerClassName, "aria-label": ariaLabel, "aria-haspopup": "true", "aria-expanded": isOpen, ref: this.saveRef('openerRef'), onKeyDown: this.handleKeyDown, onMouseDown: this.toggleOpen, tabIndex: isFocusable ? 0 : -1, "data-hook": dataHook }, children),
            React.Children.count(content) > 0 && (React.createElement(ScrollbarWrapper, { dataHook: "popover-content", className: classnames(styles.content, className, {
                    [styles.open]: isOpen,
                    [styles.closing]: isClosing,
                    [styles.left]: dropdownPosition === 'left',
                    [styles.right]: dropdownPosition === 'right',
                }) },
                React.createElement("div", { ref: this.saveRef('contentRef'), "aria-hidden": !isOpen, onMouseDown: this.toggleOpen, onKeyDown: this.handleContentKeydown }, isOpen && content)))));
    }
}
Popover.defaultProps = {
    isFocusable: true,
    onToggle: noop,
    ariaRole: 'button',
    dataHook: 'open-popover',
    focusContentOnOpen: true,
    isOpen: false,
};
//# sourceMappingURL=popover.js.map